export default __webpack_public_path__ + "src/assets/ant-logo.a121ac08debb5f6f9d7387f1bbd77425.png";